export default __webpack_public_path__ + "static/Why-TekRevol-As-Your-API-Integration-bada7d0b7c6ca957ac0d60cfde17ca96.webp";